<script setup>
import { computed } from "vue";
import { useUiStore } from '@/store/uiStore'
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";
import { applySidebarColor } from "@/assets/js/helpers/theme";

const ui = useUiStore()
// state
const isRTL = computed(() => ui.isRTL);
const sidebarType = computed(() => ui.sidebarType);
const toggleConfigurator = () => ui.toggleConfigurator();

// mutations

const darkMode = () => {
  const newValue = !ui.darkMode;
  ui.setDarkMode(newValue);
  setSidebarType(newValue ? "bg-default" : "bg-white");
  newValue ? activateDarkMode() : deactivateDarkMode();

};
const setSidebarType = (type) => {
  ui.setSidebarType(type);
};

const sidebarColor = (color) => {
  ui.setSidebarColor(color);
  applySidebarColor(color);

  // 🔽 ENVÍA el color al iframe (si existe)
  const iframe = document.querySelector("iframe");
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(
      {
        type: "sidebarColor",
        color: color,
      },
      "*"
    );
  }
};

</script>
<template>
  <div class="fixed-plugin">
    <a class="px-3 py-2 fixed-plugin-button text-dark position-fixed" @click="toggleConfigurator">
      <i class="py-2 fa fa-cog"></i>
    </a>
    <div class="shadow-lg card">
      <div class="pt-3 pb-0 bg-transparent card-header m-0">
        <div class="mt-4" @click="toggleConfigurator" :class="isRTL ? 'float-start' : 'float-end'">
          <button class="p-0 btn btn-link text-dark fixed-plugin-close-button">
            <i class="fa fa-close"></i>
          </button>
        </div>
        <div class="" :class="isRTL ? 'float-end' : 'float-start'">
          <h5 class="mt-3 mb-0">Configuración</h5>
          <p>Vea nuestras opciones del panel de control.</p>
        </div>

        <!-- End Toggle Button -->
      </div>
      <hr class="my-1 horizontal dark" />
      <div class="pt-0 card-body pt-sm-3">
        <!-- Sidebar Backgrounds -->
        <div>
          <h6 class="mb-0">Color de botones de navegación</h6>
        </div>
        <a href="#" class="switch-trigger background-color">
          <div class="my-2 badge-colors" :class="isRTL ? 'text-end' : ' text-start'">
            <span class="badge filter bg-gradient-primary active" data-color="primary"
              @click="sidebarColor('primary')"></span>
            <span class="badge filter bg-gradient-dark" data-color="dark" @click="sidebarColor('dark')"></span>
            <span class="badge filter bg-gradient-info" data-color="info" @click="sidebarColor('info')"></span>
            <span class="badge filter bg-gradient-success" data-color="success" @click="sidebarColor('success')"></span>
            <span class="badge filter bg-gradient-warning" data-color="warning" @click="sidebarColor('warning')"></span>
            <span class="badge filter bg-gradient-danger" data-color="danger" @click="sidebarColor('danger')"></span>
          </div>
        </a>
        <!-- Sidenav Type -->
        <div class="mt-3">
          <h6 class="mb-0">Tipo de barra de menú</h6>
          <p class="text-sm">Elija entre 2 tipos diferentes de navegación lateral.</p>
        </div>
        <div class="d-flex gap-2">
          <button id="btn-white" class="btn w-100 px-3 mb-2" :class="sidebarType === 'bg-white'
            ? 'bg-gradient-success'
            : 'btn-outline-success'
            " @click="setSidebarType('bg-white')">
            Claro
          </button>
          <button id="btn-dark" class="btn w-100 px-3 mb-2" :class="sidebarType === 'bg-default'
            ? 'bg-gradient-success'
            : 'btn-outline-success'
            " @click="setSidebarType('bg-default')">
            Oscuro
          </button>
        </div>
        <!-- <p class="mt-2 text-sm d-xl-none d-block">
          You can change the sidenav type just on desktop view.
          
        </p> -->
        <!-- Navbar Fixed -->
        <!-- Navbar Fixed -->
        <!-- <div class="mt-3 d-flex">
          <h6 class="mb-0">Navbar Fixed</h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="mt-1 form-check-input" :class="isRTL ? 'float-end  me-auto' : ' ms-auto'" type="checkbox"
              id="navbarFixed" :checked="isNavFixed" @click="navbarFixed" />
          </div>
        </div> -->

        <hr class="horizontal dark my-4" />
        <div class="mt-2 mb-5 d-flex">
          <h6 class="mb-0" :class="isRTL ? 'ms-2' : ''">Tema Claro / Oscuro</h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="form-check-input mt-1 ms-auto" type="checkbox" :checked="ui.darkMode"
              @click="darkMode" />
          </div>
        </div>
        <!-- <a class="btn bg-gradient-dark w-100" href="https://www.creative-tim.com/product/vue-argon-dashboard">Free
          Download</a>
        <a class="btn btn-outline-dark w-100"
          href="https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/">View documentation</a>
        <div class="text-center w-100">
          <a class="github-button" href="https://github.com/creativetimofficial/vue-argon-dashboard"
            data-icon="octicon-star" data-size="large" data-show-count="true"
            aria-label="Star creativetimofficial/vue-argon-dashboard on GitHub">Star</a>
          <h6 class="mt-3">Thank you for sharing!</h6>
          <a href="https://twitter.com/intent/tweet?text=Check%20Vue%20Argon%20Dashboard%202%20made%20by%20%40CreativeTim%20%23webdesign%20%23dashboard%20%vuejs3&amp;url=https%3A%2F%2Fwww.creative-tim.com%2Fproduct%vue-argon-dashboard"
            class="mb-0 btn btn-dark me-2" target="_blank">
            <i class="fab fa-twitter me-1" aria-hidden="true"></i> Tweet
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/vue-argon-dashboard"
            class="mb-0 btn btn-dark me-2" target="_blank">
            <i class="fab fa-facebook-square me-1" aria-hidden="true"></i> Share
          </a> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
